const AFFILIATE_NEXT_PATH = "/affiliate";

export const getSafeNextPath = (next: string | null) => {
  if (next === AFFILIATE_NEXT_PATH || next === "/settings/affiliate") {
    return AFFILIATE_NEXT_PATH;
  }

  return "/";
};

export const getAffiliateLoginPath = () =>
  `/auth/login?intent=affiliate&next=${encodeURIComponent(AFFILIATE_NEXT_PATH)}`;

export const buildAuthQuery = (intent: string | null, next: string | null) => {
  const params = new URLSearchParams();

  if (intent === "affiliate") {
    params.set("intent", "affiliate");
    params.set("next", getSafeNextPath(next));
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};
